import React from "react";
import { TableRow, TableCell } from "@material-ui/core";
import { DPTable, DPErrorMessage, DPComponentLoader } from "Components/DP";
import pretty from "Shared/pretty";
import useStyles from "./styles";
import { useDDUConsentReportHook } from "./useDDUConsentReportHook";
import { ROWS_PER_COMPLIANCE_REPORT_PAGE } from "../../ComplianceReports";
import { Header } from "Components/DP/DPTable/DPTable";
import { useReportHeaderOptions } from "Components/Shared/Reports/useReportHeaderOpions";

const DDUConsentTableHeaders: Header[] = [
  "User ID",
  "Pay Group",
  "Terms of Use Signed Date",
  "First Transfer Date",
  { label: "DailyPay Status", align: "center" },
];

export const DDUConsentTable = () => {
  const classes = useStyles();
  const { data, onChangePage, loading, error, page } = useDDUConsentReportHook();
  const { visibleHeaders, showPayGroupColumn } = useReportHeaderOptions(DDUConsentTableHeaders);

  if (error) return <DPErrorMessage />;

  return (
    <DPTable
      className={classes.table}
      headers={visibleHeaders}
      rowsPerPage={ROWS_PER_COMPLIANCE_REPORT_PAGE}
      count={data?.totalCount}
      onChangePage={onChangePage}
      loading={loading}
      page={page}
    >
      <DPComponentLoader
        isLoading={loading}
        kind="table"
        awaitComponent={(
          <>
            {data?.items.map(dduData => {
              const termsAcceptedAt = dduData.employee.termsAcceptedAt;
              return (
                <TableRow hover key={dduData.id}>
                  <TableCell>
                    {dduData.externalId}
                  </TableCell>
                  {
                    showPayGroupColumn && (
                      <TableCell>
                        {dduData.company.payGroup}
                      </TableCell>
                    )
                  }
                  <TableCell>
                    {termsAcceptedAt && pretty.date(termsAcceptedAt)}
                  </TableCell>
                  <TableCell>
                    {pretty.date(dduData.firstAdvanceCreatedAt)}
                  </TableCell>
                  <TableCell align="center">
                    {pretty.titleizeWord(dduData.status)}
                  </TableCell>
                </TableRow>
              );
            })}
          </>
        )}
      />
    </DPTable>
  );
};
